 import * as React from 'react'
 import { Request } from 'fetchboi'
 
 export const uploadPDF = Request.register({
   endpoint: '/gallery/pdf?CongressSlug=:CongressSlug',
   method: 'post',
 })
 